/**
 * ArraySorter - Utility for sorting arrays
 * 
 * Extracted from TypesetterWorkerClient for better modularity and testability.
 * 
 * This utility provides functions for sorting arrays in ascending and descending order,
 * which is useful for consistent sorting behavior across the codebase.
 */

/**
 * Sort numbers in ascending order
 * 
 * @param a - First number
 * @param b - Second number
 * @returns Comparison result for ascending sort
 */
export function sortAscending(a: number, b: number): number {
  return a - b;
}

/**
 * Sort numbers in descending order
 * 
 * @param a - First number
 * @param b - Second number
 * @returns Comparison result for descending sort
 */
export function sortDescending(a: number, b: number): number {
  return b - a;
}

/**
 * Sort an array of numbers in ascending order
 * 
 * @param array - Array of numbers to sort
 * @returns New sorted array (does not mutate original)
 */
export function sortNumbersAscending(array: number[]): number[] {
  return [...array].sort(sortAscending);
}

/**
 * Sort an array of numbers in descending order
 * 
 * @param array - Array of numbers to sort
 * @returns New sorted array (does not mutate original)
 */
export function sortNumbersDescending(array: number[]): number[] {
  return [...array].sort(sortDescending);
}

